var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject,style:(_vm.styleObject)},[_c('img',_vm._b({class:_vm.$style.image,style:(_vm.customStyle),attrs:{"src":_vm.path}},'img',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }